import { ExportAsyncApi } from "./export-async-api";
import { ExportAsyncForm } from "./export-async-form";
import { ExportAsyncHandler } from "./export-async-handler";
import { ExportAsyncListener } from "./export-async-listener";

export class ExportAsyncSetup {
    public static init(root: HTMLElement): void {
        if (!(root instanceof HTMLFormElement)) {
            return;
        }

        const form = new ExportAsyncForm(root);
        if (form.isInitialized()) {
            return;
        }
        form.markInitialized();

        const handler = new ExportAsyncHandler(form, new ExportAsyncApi());
        new ExportAsyncListener(form, handler).register();
    }
}
